import React, { useState } from "react";

const SellerManagementDetails = () => {
  const [showModal, setShowModal] = useState(false);

  const tags = [
    "Electronics",
    "Software",
    "Software",
    "Software",
    "Electronics",
    "Electronics",
    "Software",
    "Software",
    "Electronics",
    "Software",
    "Electronics",
    "Software",
  ];

  return (
    <div className="p-6 bg-white border-2 border-gray-300 rounded-md w-full mx-auto">
      <h2 className="text-lg font-medium mb-4 underline text-[#333333]">
        Buyer Management Details
      </h2>
      <table className="w-full">
        <tbody>
          <tr>
            <td className="p-3 font-medium text-sm text-[#333333]">
              Buyer Added By:
            </td>
            <td className="p-3 text-sm text-[#333333]">Administrator</td>
            <td className="p-3 font-medium text-sm border-l border-gray-300 text-[#333333]">
              Buyer Added Date:
            </td>
            <td className="p-3 text-sm text-[#333333]">12/11/2024</td>
          </tr>
          <tr>
            <td className="p-3 font-medium text-sm text-[#333333]">
              Buyer Source:
            </td>
            <td className="p-3 text-sm text-[#333333]">....................</td>
            <td className="p-3 font-medium text-sm border-l border-gray-300 text-[#333333]">
              Buyer Stage:
            </td>
            <td className="p-3 text-sm text-[#333333]">....................</td>
          </tr>
          <tr>
            <td className="p-3 font-medium text-sm text-[#333333]">
              Buyer Last Updated By:
            </td>
            <td className="p-3 text-sm text-[#333333]">Executives</td>
            <td className="p-3 font-medium text-sm border-l border-gray-300 text-[#333333]">
              Next Step:
            </td>
            <td className="p-3 text-sm text-[#333333]">abucr3@gmail.com</td>
          </tr>
          <tr>
            <td className="p-3 font-medium text-sm text-[#333333]">
              Buyer Owner:
            </td>
            <td className="p-3 text-sm text-[#333333]">....................</td>
            <td className="p-3 font-medium text-sm border-l border-gray-300 text-[#333333]">
              Buyer Recommended For:
            </td>
            <td className="p-3 text-sm text-[#333333]">....................</td>
          </tr>

          <tr>
            <td className="p-3 font-medium text-sm text-[#333333] align-top">
              Tags:
            </td>
            <td className="p-3 text-sm text-[#333333] align-top" colSpan={2}>
              <div className="flex flex-wrap items-start gap-1">
                {tags.slice(0, 2).map((tag, i) => (
                  <span
                    key={i}
                    className="bg-gray-100 px-2 py-1 text-xs rounded-md"
                  >
                    {tag}
                  </span>
                ))}
                
                {tags.length > 6 && (
                  <button
                    onClick={() => setShowModal(true)}
                    className="text-blue-600 text-xs underline ml-2"
                  >
                    View all
                  </button>
                )}
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      {/* Modal for all tags */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
          <div className="bg-white rounded-lg shadow-lg w-[600px] p-6 relative">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-md font-semibold flex items-center">
                <span className="mr-2">ℹ️</span> Tags
              </h3>
              <button
                onClick={() => setShowModal(false)}
                className="text-xl font-bold"
              >
                &times;
              </button>
            </div>

            <div className="max-h-60 overflow-y-auto border p-4 rounded">
              <div className="flex flex-wrap gap-2">
                {tags.map((tag, index) => (
                  <span
                    key={index}
                    className="bg-gray-100 px-2 py-1 text-sm rounded-md"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </div>

            <div className="flex justify-end mt-6">
              <button
                onClick={() => setShowModal(false)}
                className="bg-blue-600 text-white px-4 py-1 rounded"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SellerManagementDetails;
